
import { LOGIN, SET_SHOW_PASSWORD, SHOW_ACCOUNT_NAME_ERROR, SHOW_PASSWORD_ERROR } from './loginActions'

const initialState = {
  showPassword: false,
  accountNameError: '',
  passwordError: '',
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case LOGIN:
      return { ...state, accountNameError: '', passwordError: '' }
    case SET_SHOW_PASSWORD:
      return { ...state, showPassword: payload }
    case SHOW_ACCOUNT_NAME_ERROR:
      return { ...state, accountNameError: payload }
    case SHOW_PASSWORD_ERROR:
      return { ...state, passwordError: payload }
    default:
      return state
  }
}
